import { collectAllMeasures, getMutableComponentProps, removeMeasures } from "./utils";
import { CustomVisitorEnum } from "hooks/widget-data/datapoints-api/visitors/custom/customVisitors";
export const setupCffModelIdContext = (componentProps, allDependencies, originalComponentProps) => {
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const measures = collectAllMeasures(mutableComponentProps);
    for (const measure of measures) {
        const context = measure.context;
        if (context?.cffModelId === "__CFF_MODEL_ID__") {
            context.cffModelId = allDependencies.cffModelId;
        }
    }
    return mutableComponentProps;
};
export const filterCffModelMeasures = (componentProps, allDependencies, originalComponentProps) => {
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    // If no cffModelId is available, remove measures that depend on it
    if (!allDependencies.cffModelId) {
        // Find measures that have cffModelId in their context (meaning they require a model)
        const measuresToRemove = [];
        const allMeasures = collectAllMeasures(mutableComponentProps);
        allMeasures.forEach((measure) => {
            const context = measure.context;
            // Check if this measure has cffModelId property (regardless of its value)
            if (context && "cffModelId" in context) {
                measuresToRemove.push(measure.name || "");
            }
        });
        // Remove the measures from datapointParams
        removeMeasures(mutableComponentProps, (measure) => {
            const context = measure.context;
            return context !== undefined && "cffModelId" in context;
        });
        // Remove from compositeObjectBuilder measures
        if (mutableComponentProps.pipelineParameter?.compositeObjectBuilder?.measures) {
            mutableComponentProps.pipelineParameter.compositeObjectBuilder.measures =
                mutableComponentProps.pipelineParameter.compositeObjectBuilder.measures.filter((measureName) => !measuresToRemove.includes(measureName));
        }
        // Remove series from highchartsTimeSeriesCreation that use filtered measures
        const customVisitors = mutableComponentProps.pipelineParameter?.customVisitorsReducer;
        if (customVisitors) {
            const timeSeriesVisitor = customVisitors.find((v) => v.method === CustomVisitorEnum.highchartsTimeSeriesCreation);
            if (timeSeriesVisitor?.arguments?.series) {
                timeSeriesVisitor.arguments.series = timeSeriesVisitor.arguments.series.filter((serie) => !measuresToRemove.includes(serie.field));
            }
        }
    }
    return mutableComponentProps;
};
